module.exports = __webpack_public_path__ + "static/img/products application_normal1.07dfd970.jpg";